
<template>
  <div
    :class="[
      subject == 1 || subject == 2 || subject == 3
        ? 'course' + subject
        : 'course',
      isNoviceClass ? 'novice_class' : '',
    ]"
  >
    <compose
      v-if="showCompose"
      style="position: absolute; top: 0; left: 0; z-index: 10"
    />
    <pdf-list
      v-if="showCoursePdf"
      style="position: absolute; top: 0; left: 0; z-index: 10"
    ></pdf-list>
    <div class="header" v-if="!showCompose && !showCoursePdf">
      <span @click="go_class" class="back cursor"></span>
      <h2>{{ class_name }}</h2>
      <div class="pdf-btn cursor" @click="goPdfPage">
        <img src="../../../assets/img/class/pdf_files.png" alt="学习资料入口"/>
        <span>学习资料</span>
      </div>
    </div>
    <div class="lottie"></div>
    <course-list
      :subType="subType"
      v-show="!showCompose && !showCoursePdf"
      ref="courseList"
    ></course-list>
    <div
      class="dailyTasks cursor"
      @click="dailyTasksClick"
      v-if="dailyTasksShow && !showCompose && !showCoursePdf"
    ></div>
  </div>
</template>

<script>
import course_list from "./course_list";
import { mapMutations, mapState } from "vuex";
import lottie from "lottie-web-limi";
import compose from "../courseCompose/courseCompose";
import course_pdf_list from "../coursePdf/course_pdf_list"
export default {
  name: "course",
  data() {
    return {
      anim: "",
      subType: "",
      dailyTasksShow: false,
    };
  },
  components: {
    "course-list": course_list,
    "pdf-list": course_pdf_list,
    compose,
  },
  computed: {
    ...mapState(["class_name", "subject", "isNoviceClass", "showCompose", "showCoursePdf"]),
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setLottieSize);
  },
  mounted() {
    this.setLottieSize();
    window.addEventListener("resize", this.setLottieSize);
    this.handleAnimation();
  },
  methods: {
    ...mapMutations(["saveLessonInfo","saveBaseLessonInfo","saveClassInfo"]),
    dailyTasksClick() {
      this.$refs.courseList.showText = "电脑端暂不支持此活动，欢迎您使用手机登录【狸米新启航】进行参与！";
    },
    go_class() {
      //返回班级列表页
      this.$router.push("/class");
      this.saveLessonInfo({});
      this.saveBaseLessonInfo({});
      this.saveClassInfo({});
    },
    goPdfPage() {
      this.$store.commit('saveShowCoursePdf', true);
    },
    handleAnimation() {
      const subTypes = {
        1: "shuxue",
        2: "yuwen",
        3: "yingyu",
        4: "xinshou",
        5: "beiyong",
      };
      let subType = this.isNoviceClass
        ? 4
        : this.subject != 1 && this.subject != 2 && this.subject != 3
        ? 5
        : this.subject;
      this.subType = subTypes[subType];
      this.anim = lottie.loadAnimation({
        container: document.querySelector(".lottie"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: true,
        autoplay: true,
        path: `/static/lottie/${this.subType}/a.json`,
      });
    },
    playAnim() {
      this.anim.play();
      // this.anim.goToAndStop(200)
    },
    setLottieBoxSize() {
      let clientWidth = document.body.clientWidth;
      let clientHeight = document.body.clientHeight;
      let scaleWindow = clientWidth / clientHeight;
      let scaleLottie = 1280 / 720;
      let lottieDom = document.querySelector(".lottie");
      let scale;
      let offset;
      if (scaleWindow > scaleLottie) {
        scale = clientWidth / 1280;
        lottieDom.style.height = 100 * scale + "%";
        lottieDom.style.width = "100%";
        offset = (100 * scale - 100) / 2;
        lottieDom.style.top = `-${offset}%`;
        lottieDom.style.left = `0`;
        if (clientHeight < 720) {
          let scaleY = 720 / clientHeight;
          console.log(scaleY);
          lottieDom.style.width = 100 * scale + "%";
          lottieDom.style.height = 720 * scaleY + "px";
          lottieDom.style.left = `-${(100 * scale - 100) / 2}%`;
        }
      } else if (scaleWindow < scaleLottie) {
        scale = 720 / clientHeight;
        lottieDom.style.width = 100 / scale + "%";
        lottieDom.style.height = "100%";
        offset = (100 / scale - 100) / 2;
        // console.log((100 / scale - 100),lottieDom.style.width)
        lottieDom.style.left = `-${offset}%`;
        lottieDom.style.top = `0`;
      }
    },
    setLottieSize() {
      let clientWidth = document.body.clientWidth;
      let clientHeight = document.body.clientHeight;
      let lottieDom = document.querySelector(".lottie");
      if (!lottieDom) return;
      if (clientHeight >= 720 && clientWidth >= 1280) {
        if (clientWidth / clientHeight > 1280 / 720) {
          lottieDom.style.width = "100%";
          lottieDom.style.height = (720 / 1280) * clientWidth + "px";
        } else {
          lottieDom.style.height = "100%";
          lottieDom.style.width = (1280 / 720) * clientHeight + "px";
        }
      } else if (clientHeight > 720 && clientWidth < 1280) {
        lottieDom.style.height = "100%";
        lottieDom.style.width = (1280 / 720) * clientHeight + "px";
      } else if (clientHeight < 720 && clientWidth < 1280) {
        lottieDom.style.height = "720px";
        lottieDom.style.width = "1280px";
      } else if (clientHeight < 720 && clientWidth > 1280) {
        lottieDom.style.width = "100%";
        lottieDom.style.height = (720 / 1280) * clientWidth + "px";
      }
    },
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.dailyTasks {
  position: absolute;
  width: 45px;
  height: 115px;
  top: 0;
  right: 70px;
  background: url("../../../assets/img/course/dailyTasks.png") no-repeat;
  background-size: cover;
  z-index: 99;
}
.course,
.course1,
.course2,
.course3 {
  width: 100%;
  height: 100%;
  background: url(/static/img/course/bg0.png) no-repeat;
  position: relative;
  overflow: hidden;
  background-size: cover;
}
.lottie {
  width: 100%;
  height: 720px;
  position: absolute;
  z-index: 0;
}
.course1 {
  background: url(/static/img/course/bg1.png) no-repeat;
  background-size: cover;
}
.course2 {
  background: url(/static/img/course/bg2.png) no-repeat;
  background-size: cover;
}
.course3 {
  background: url(/static/img/course/bg3.png) no-repeat;
  background-size: cover;
}
.novice_class {
  background: url(/static/img/course/novice_bg.png) no-repeat;
  background-size: cover;
}
.header {
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 83px;
  padding-top: 20px;
  .back {
    position: absolute;
    width: 56px;
    height: 56px;
    background: url("../../../assets/img/common/arrow_left1.png") no-repeat
      center center;
    background-size: 100% 100%;
    border-radius: 50%;
    left: 30px;
    top: 20px;
    &:hover {
      background: rgba(0, 0, 0, 0.08)
        url("../../../assets/img/common/arrow_left1.png") no-repeat center
        center;
      background-size: 100% 100%;
    }
  }
  h2 {
    font-family: PingFang_Medium;
    font-weight: normal;
    font-size: 30px;
    padding-top: 10px;
    color: #fff;
  }
  .pdf-btn {
    position: absolute;
    top: 30px;
    right: 100px;
    width: 176px;
    height: 50px;
    border-radius: 25px;
    font-size: 0;
    //background-color: #0a90d7;
    display: flex;
    img {
      display: inline-block;
      width: 35px;
      height: 40px;
      margin: 0 8px;
    }
    span {
      line-height: 45px;
      font-size: 22px;
      font-weight: 600;
      //font-family: HYZhengYuan;
      color: #ffffff;
    }
  }
  i {
    position: absolute;
    top: 10px;
    right: 30px;
    width: auto;
    height: 50px;
    font-family: Roboto_Regular;
    background: rgba(0, 0, 0, 0.15) url(../../../assets/img/common/coin.png)
      no-repeat left center;
    border-radius: 25px;
    background-size: 50px 50px;
    font-size: 24px;
    line-height: 50px;
    color: #007a9c;
    text-align: center;
    padding: 0 22px 0 64px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/course/course.vue